import { Search, X } from 'lucide-react';

export default function AdminFilterBar({ filters, onFilterChange, onReset, children }) {
  return (
    <div className="bg-white rounded-xl border border-[#E8E6F8] p-4 mb-5 flex flex-wrap gap-3 items-center">
      {/* Search */}
      {filters.search !== undefined && (
        <div className="relative flex-1 min-w-[180px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-[#9CA3AF]" />
          <input
            type="text"
            placeholder="Search…"
            value={filters.search}
            onChange={(e) => onFilterChange('search', e.target.value)}
            className="w-full pl-9 pr-3 py-2 text-sm font-body border border-[#E8E6F8] rounded-lg bg-[#F5F4FB] text-[#1A1A2E] placeholder:text-[#9CA3AF] focus:outline-none focus:ring-1 focus:ring-[#6C63FF]/50"
          />
        </div>
      )}

      {/* Additional filters passed as children */}
      {children}

      {/* Reset */}
      <button
        onClick={onReset}
        className="flex items-center gap-1.5 text-xs font-body text-[#6B7280] hover:text-[#1A1A2E] px-3 py-2 border border-[#E8E6F8] rounded-lg hover:bg-[#F5F4FB] transition-colors"
      >
        <X className="h-3 w-3" />
        Reset
      </button>
    </div>
  );
}
